const Menu = () => {
	return <div className="menu">Menu</div>;
};

export default Menu;
